import React from 'react'
import PropTypes from 'prop-types'
import connectPropTypes from './utilities/connectPropTypes'
import EmailInputAndValidation from './components/EmailInputAndValidation'
import deviceDetect from './utilities/deviceDetect'
import styles from './LoginEmail.icss'

class LoginEmail extends React.Component {
	constructor(props) {
		super(props)

		this.state = { email: '' }

		this.handleLogin = this.handleLogin.bind(this)
		//	On iOS using instagram or pwa, we need to paste the url in when using email.
		this.needsUrlPasted = deviceDetect.isIos() && (deviceDetect.isInstagram() || deviceDetect.isPwa())
	}

	componentDidMount() {
		this.props.appShowBottomBar(false)
	}

	componentDidUpdate() {
		if (this.props.authEmailLoginSuccess) {
			this.props.authEmailSent({ emailSent: this.state.email })
			this.props.appRedirect('/login/email/sent')
		}
	}

	componentWillUnmount() {
		this.props.authReset()
	}

	handleLogin(email) {
		this.props.authEmailLogin({ email })
		this.setState({ email })
	}

	render() {
		return (
			<div className={styles.loginEmailWrapper}>
				<section className={styles.infoWrapper}>
					<h2>{this.context.translate('Log in with your Email')}</h2>
					{!this.needsUrlPasted && (
						<p>
							{this.context.translate('We’ll send a login link to your email, once it arrives just click it and you’ll be logged in!')}
						</p>
					)}
					{this.needsUrlPasted && (
						<p>
							{this.context.translate('We’ll send a login link to your email, once it arrives copy it, come back here and paste it in.')}
						</p>
					)}
				</section>
				<section className={styles.formWrapper}>
					<EmailInputAndValidation
						fullWidth
						emailHandler={this.handleLogin}
						label={this.context.translate('E-mail address')}
						buttonText={this.context.translate('Submit')}
					/>
					{this.props.authEmailLoginFail && (
						<div>
							<span className={styles.validationError}>{this.props.authEmailLoginError ? this.props.authEmailLoginError : this.context.translate('Please enter a valid email')}</span>
						</div>
					)}
				</section>
				<section className={styles.termsWrapper}>
					<div className={styles.termsPrivacy}>
						<a href="https://kit.fit/terms" target="_blank" rel="noreferrer noopener" className={styles.tpLink}>{this.context.translate('Terms of use')}</a>
						<a href="https://kit.fit/privacy" target="_blank" rel="noreferrer noopener" className={styles.tpLink}>{this.context.translate('Privacy')}</a>
					</div>
				</section>
			</div>
		)
	}
}

LoginEmail.contextTypes = {
	translate: PropTypes.func
}

LoginEmail.propTypes = {
	appRedirect: PropTypes.func.isRequired,
	authEmailLoginFail: PropTypes.bool,
	authEmailLoginSuccess: PropTypes.bool,
	authEmailLoginError: PropTypes.string,
	authEmailSent: PropTypes.func.isRequired,
	appShowBottomBar: PropTypes.func.isRequired,

	authEmailLogin: PropTypes.func.isRequired,
	authReset: PropTypes.func.isRequired
}

LoginEmail.defaultProps = {
	authEmailLoginFail: false,
	authEmailLoginSuccess: false,
	authEmailLoginError: undefined
}

export const testing = {
	LoginEmail
}

export default connectPropTypes(LoginEmail)



// WEBPACK FOOTER //
// ./src/LoginEmail.jsx